import createVueApp from '@phoenix/createVueApp';
import UspTabs from '@maison/components/usp/UspTabs.vue';

document.querySelectorAll('.phoenix-usp-block').forEach((el) => {
  const app = createVueApp();
  app.component('UspTabs', UspTabs);
  app.mount(el);
});
